import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { PaginationParams } from 'models';

export const getCounteroffers = createAsyncThunk(
	'secondaryMarket/getCounteroffers',
	async (params?: PaginationParams) => {
		return await SecondaryMarketService.getCounteroffers(params);
	},
);
